import { useState } from 'react';

import { ConfirmForm, LoginFooter, SignUpForm } from 'components';

const SignUp = () => {
  const [email, setEmail] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [company, setCompany] = useState<string>('');
  const [country, setCountry] = useState<string>('');
  const [purpose, setPurpose] = useState<string>('');
  const [isConfirming, setIsConfirming] = useState<boolean>(false);

  return (
    <div className="flex h-screen max-h-screen w-full flex-col bg-white">
      <main className="flex w-full flex-1 items-center justify-center">
        {isConfirming ? (
          <ConfirmForm email={email} name={name} company={company} country={country} purpose={purpose} />
        ) : (
          <SignUpForm 
            email={email}
            setEmail={setEmail}
            name={name}
            setName={setName}
            company={company}
            setCompany={setCompany}
            country={country}
            setCountry={setCountry}
            purpose={purpose}
            setPurpose={setPurpose}
            setIsConfirming={setIsConfirming} />
        )}
      </main>
      <LoginFooter />
    </div>
  );
};

export default SignUp;
